import { MenuItem } from 'primeng/api';

export const ItemsLayoutMainOptions: MenuItem[] = [
  {
    automationId: 'PR_002',
    label: 'menu_main.products',
    icon: 'pi pi-fw pi-tags',
    routerLink: 'products/list',
    tooltip: 'main_layout.products_description',
  },
  {
    automationId: 'IM_004',
    label: 'menu_main.inventories',
    icon: 'pi pi-fw pi-calculator',
    routerLink: 'inventories/summary-list',
    tooltip: 'main_layout.inventories_description',
  },
  {
    automationId: 'MV_001',
    label: 'menu_main.movements',
    icon: 'pi pi-fw pi-arrow-right-arrow-left',
    routerLink: 'moves/list',
    tooltip: 'main_layout.movements_description',
  },
  {
    automationId: 'SO_002',
    label: 'menu_main.store_orders',
    icon: 'pi pi-fw pi-cart-plus',
    routerLink: 'operations/store-orders/list',
    tooltip: 'main_layout.store_orders_description',
  },
  {
    automationId: 'LS_002',
    label: 'menu_main.tracking_orders',
    icon: 'pi pi-fw pi-qrcode',
    routerLink: 'logistics/tracking-orders/list',
    tooltip: 'main_layout.tracking_orders_description',
  },
  {
    automationId: 'PRNT_002',
    label: 'menu_main.print_orders',
    icon: 'pi pi-fw pi-print',
    routerLink: 'print-orders/list',
    tooltip: 'main_layout.print_orders_description',
  },
  {
    automationId: 'PK_003',
    label: 'menu_main.packing_list',
    icon: 'pi pi-fw pi-list',
    routerLink: 'packings/list',
    tooltip: 'main_layout.packing_list_description',
  },
  {
    // Visibility controlled by the packing-audits web module permission
    // (PKA_002 = view/list). menuValidator hides this quick-access tile when
    // the user does not have the PKA_002 code in active_web_modules.
    automationId: 'PKA_002',
    label: 'menu_main.packing_audits',
    icon: 'pi pi-fw pi-verified',
    routerLink: 'operations/packing-audits/list',
    tooltip: 'main_layout.packing_audits_description',
  },
  {
    automationId: 'AD_002',
    label: 'menu_main.inventory',
    icon: 'pi pi-fw pi-calculator',
    routerLink: 'audits/list',
    tooltip: 'main_layout.inventory_description',
  },
  {
    automationId: 'AD_CL_002',
    label: 'menu_main.inventory',
    icon: 'pi pi-fw pi-calculator',
    routerLink: 'audits-classic/list',
    tooltip: 'main_layout.inventory_description',
  },
  {
    automationId: 'SCT_001',
    label: 'menu_main.screens',
    icon: 'pi pi-fw pi-desktop',
    routerLink: 'screen-control',
    tooltip: 'main_layout.screens_description',
  },
  {
    automationId: 'INT_APPS_001',
    label: 'menu_main.integration_apps',
    icon: 'pi pi-fw pi-sitemap',
    routerLink: 'integration-apps',
    tooltip: 'main_layout.integration_apps_description',
  },
];

/**
 * Array objects for main-sibedar menu
 * @type {MenuItem[]} Array for objects compatible with menu primeng
 *
 */
export const ItemsMenu: MenuItem[] = [
  {
    label: 'menu_main.dashboards',
    icon: 'pi pi-fw pi-chart-line',
    visible: true,
    routerLink: 'dashboards',
    items: [],
  },
  {
    automationId: 'CT_000',
    label: 'menu_main.thirds',
    icon: 'pi pi-fw pi-users',
    items: [
      {
        automationId: 'CT_001',
        label: 'menu_main.thirds_new',
        icon: 'pi pi-fw pi-user-plus',
        routerLink: 'third-party/create',
      },
      {
        automationId: 'CT_002',
        label: 'menu_main.thirds_list',
        icon: 'pi pi-fw pi-list',
        routerLink: 'third-party/list',
      },
    ],
  },
  {
    automationId: 'PR_000',
    label: 'menu_main.operations',
    icon: 'pi pi-fw pi-briefcase',
    visible: true,
    items: [
      {
        automationId: 'PR_000',
        label: 'menu_main.products',
        icon: 'pi pi-fw pi-tags',
        items: [
          {
            automationId: 'PR_002',
            label: 'menu_main.products_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'products/list',
          },
          {
            automationId: 'IM_006',
            label: 'menu_main.inactivation_tags',
            icon: 'pi pi-fw pi-tag',
            routerLink: 'products/item-inactive',
          },
          {
            automationId: 'IM_008',
            label: 'menu_main.inactivation_records',
            icon: 'pi pi-fw pi-history',
            routerLink: 'products/item-inactivation-records',
          },
        ],
      },
      {
        automationId: 'IM_000',
        label: 'menu_main.inventories',
        icon: 'pi pi-fw pi-calculator',
        visible: true,
        items: [
          {
            automationId: 'IM_004',
            label: 'menu_main.inventory_dashboards',
            icon: 'pi pi-fw pi-chart-bar',
            routerLink: 'inventories/dashboards',
          },
          {
            automationId: 'IM_004',
            label: 'menu_main.inventory_summary',
            icon: 'pi pi-fw pi-table',
            routerLink: 'inventories/summary-list',
          },
          {
            automationId: 'IM_006',
            label: 'menu_main.inventory_store_summary',
            icon: 'pi pi-fw pi-building',
            routerLink: 'inventories/store-summary',
          },
          {
            automationId: 'IM_005',
            label: 'menu_main.inventory_booking',
            icon: 'pi pi-fw pi-calendar',
            routerLink: 'inventories/booking/list',
          },
          {
            automationId: 'MV_001',
            label: 'menu_main.movements',
            icon: 'pi pi-fw pi-arrow-right-arrow-left',
            routerLink: 'moves/list',
          },
        ],
      },
      {
        automationId: 'PO_000',
        label: 'menu_main.receiving',
        icon: 'pi pi-fw pi-truck',
        items: [
          {
            automationId: 'PO_001',
            label: 'menu_main.production_orders',
            icon: 'pi pi-fw pi-cart-plus',
            items: [
              {
                automationId: 'PO_002',
                label: 'menu_main.production_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'production-orders/create',
              },
              {
                automationId: 'PO_003',
                label: 'menu_main.production_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'production-orders/list',
              },
            ],
          },
          {
            automationId: 'PUO_001',
            label: 'menu_main.purchase_orders',
            icon: 'pi pi-fw pi-cart-plus',
            items: [
              {
                automationId: 'PUO_001',
                label: 'menu_main.purchase_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'purchase-orders/create',
              },
              {
                automationId: 'PUO_002',
                label: 'menu_main.purchase_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'purchase-orders/list',
              },
            ],
          },
          {
            automationId: 'PRNT_002',
            label: 'menu_main.print_orders',
            icon: 'pi pi-fw pi-print',
            routerLink: 'print-orders/list',
          },
        ],
      },
      {
        automationId: 'OP_000',
        label: 'menu_main.orders',
        icon: 'pi pi-fw pi-file',
        items: [
          {
            automationId: 'SO_000',
            label: 'menu_main.store_orders',
            icon: 'pi pi-fw pi-cart-plus',
            items: [
              {
                automationId: 'SO_001',
                label: 'menu_main.store_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'operations/store-orders/create',
              },
              {
                automationId: 'SO_002',
                label: 'menu_main.store_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'operations/store-orders/list',
              },
            ],
          },
          {
            automationId: 'DT_000',
            label: 'menu_main.distributions',
            icon: 'pi pi-fw pi-list',
            items: [
              {
                automationId: 'DT_001',
                label: 'menu_main.distribution_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'operations/distribution-orders/create',
              },
              {
                automationId: 'DT_002',
                label: 'menu_main.distribution_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'operations/distribution-orders/list',
              },
            ],
          },
          {
            automationId: 'WO_000',
            label: 'menu_main.work_orders',
            icon: 'pi pi-fw pi-file-edit',
            items: [
              {
                automationId: 'WO_001',
                label: 'menu_main.work_order_create',
                icon: 'pi pi-fw pi-plus-circle',
                routerLink: 'operations/work-orders/create',
              },
              {
                automationId: 'WO_002',
                label: 'menu_main.work_order_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'operations/work-orders/list',
              },
            ],
          },
          {
            automationId: 'PK_000',
            label: 'menu_main.packings',
            icon: 'pi pi-fw pi-box',
            items: [
              {
                automationId: 'PK_003',
                label: 'menu_main.packing_list_states',
                icon: 'pi pi-fw pi-box',
                routerLink: 'packings/list-states',
              },
              {
                automationId: 'PK_003',
                label: 'menu_main.packing_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'packings/list',
              },
            ],
          },
        ],
      },
      {
        automationId: 'LS_000',
        label: 'menu_main.logistics',
        icon: 'pi pi-fw pi-truck',
        items: [
          {
            automationId: 'LS_001',
            label: 'menu_main.shipping_orders',
            icon: 'pi pi-fw pi-list',
            routerLink: 'logistics/shipping-orders/list',
          },
          {
            automationId: 'LS_002',
            label: 'menu_main.tracking_orders',
            icon: 'pi pi-fw pi-qrcode',
            routerLink: 'logistics/tracking-orders/list',
          },
          {
            automationId: 'LS_003',
            label: 'menu_main.tracking_orders_print',
            icon: 'pi pi-fw pi-print',
            routerLink: 'logistics/tracking-orders/print',
          },
        ],
      },
      {
        automationId: 'AD_000',
        label: 'menu_main.inventory',
        icon: 'pi pi-fw pi-calculator',
        items: [
          {
            automationId: 'AD_001',
            label: 'menu_main.inventory_counts_programming',
            icon: 'pi pi-fw pi-calendar-clock',
            routerLink: 'audits/calendar',
          },
          {
            automationId: 'AD_002',
            label: 'menu_main.inventory_counts_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'audits/list',
          },
        ],
      },
      {
        // Visibility controlled by the packing-audits web module permissions
        // (active_web_modules): PKA_000 = section, PKA_001 = create,
        // PKA_002 = view/list. menuValidator hides each entry when the user
        // lacks the matching code.
        automationId: 'PKA_000',
        label: 'menu_main.packing_audits',
        icon: 'pi pi-fw pi-verified',
        items: [
          {
            automationId: 'PKA_001',
            label: 'menu_main.packing_audit_create',
            icon: 'pi pi-fw pi-plus-circle',
            routerLink: 'operations/packing-audits/create',
          },
          {
            automationId: 'PKA_002',
            label: 'menu_main.packing_audit_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'operations/packing-audits/list',
          },
        ],
      },
      {
        automationId: 'AD_CL_000',
        label: 'menu_main.inventory',
        icon: 'pi pi-fw pi-calculator',
        items: [
          {
            automationId: 'AD_CL_002',
            label: 'menu_main.inventory_counts_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'audits-classic/list',
          },
        ],
      },
    ],
  },
  {
    // Visibility is controlled by the Air Cargo web module permission
    // (active_web_modules). The backend exposes these modules with the `AC_`
    // prefix, so the automationId values must match the real `code` values
    // (AC_000..AC_005); menuValidator hides this section when the user does
    // not have the AC_000 permission.
    automationId: 'AC_000',
    label: 'menu_main.air_cargo',
    icon: 'pi pi-fw pi-send',
    visible: true,
    tooltip: 'main_layout.air_cargo_description',
    items: [
      // Guías Máster (MAWB)
      {
        automationId: 'AC_002',
        label: 'menu_main.air_cargo_mawb',
        icon: 'pi pi-fw pi-file-export',
        routerLink: 'air-cargo/master-air-waybills',
      },
      // Aeropuertos
      {
        automationId: 'AC_003',
        label: 'menu_main.air_cargo_airports',
        icon: 'pi pi-fw pi-map-marker',
        routerLink: 'air-cargo/airports',
      },
      // Aerolíneas
      {
        automationId: 'AC_004',
        label: 'menu_main.air_cargo_carriers',
        icon: 'pi pi-fw pi-truck',
        routerLink: 'air-cargo/carriers',
      },
      // Guías (HAWB)
      {
        automationId: 'AC_001',
        label: 'menu_main.air_cargo_waybills',
        icon: 'pi pi-fw pi-list',
        routerLink: 'air-cargo/list',
      },
    ],
  },
  {
    automationId: 'SL_000',
    label: 'menu_main.sales',
    icon: 'pi pi-fw pi-shopping-cart',
    items: [
      {
        automationId: 'SL_001',
        label: 'menu_main.replenishment',
        icon: 'pi pi-fw pi-refresh',
        items: [
          {
            automationId: 'SL_002',
            label: 'menu_main.showroom_catalog',
            icon: 'pi pi-fw pi-list',
            routerLink: 'sales/replenishment/showroom-catalog',
          },

          {
            automationId: 'SL_001',
            label: 'menu_main.replenishment_report',
            icon: 'pi pi-fw pi-chart-bar',
            routerLink: 'sales/replenishment-report',
          },
          {
            automationId: 'SL_001',
            label: 'menu_main.replenishment_tasks',
            icon: 'pi pi-fw pi-check-square',
            routerLink: 'sales/replenishment-tasks',
          },
        ],
      },
    ],
  },
  {
    automationId: 'SCT_000',
    label: 'menu_main.screen_control',
    icon: 'pi pi-fw pi-desktop',
    items: [
      {
        automationId: 'SCT_001',
        label: 'menu_main.screens',
        icon: 'pi pi-fw pi-desktop',
        routerLink: 'screen-control',
      },
    ],
  },
  {
    automationId: 'SETT_000',
    label: 'menu_main.settings',
    icon: 'pi pi-fw pi-cog',
    visible: true,
    items: [
      {
        automationId: 'LOC_000',
        label: 'menu_main.locations_management',
        icon: 'pi pi-fw pi-map-marker',
        items: [
          {
            automationId: 'LOC_001',
            label: 'menu_main.warehouse_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'locations/warehouses/list',
          },
          {
            automationId: 'LOC_002',
            label: 'menu_main.warehouse_create',
            icon: 'pi pi-fw pi-plus-circle',
            routerLink: 'locations/warehouses/create',
          },
          {
            automationId: 'LOC_001',
            label: 'menu_main.stores_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'locations/stores/list',
          },
          {
            automationId: 'LOC_002',
            label: 'menu_main.stores_create',
            icon: 'pi pi-fw pi-plus-circle',
            routerLink: 'locations/stores/create',
          },
          {
            automationId: 'LOC_001',
            label: 'menu_main.locations_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'locations/ubicaciones/list',
          },
          {
            automationId: 'LOC_002',
            label: 'menu_main.locations_create',
            icon: 'pi pi-fw pi-plus-circle',
            routerLink: 'locations/ubicaciones/create',
          },
          {
            automationId: 'LOC_003',
            label: 'menu_main.locations_batch_create',
            icon: 'pi pi-fw pi-objects-column',
            routerLink: 'locations/ubicaciones/batch-create',
          },
        ],
      },
      {
        automationId: 'USERS_000',
        label: 'menu_main.users_management',
        icon: 'pi pi-fw pi-users',
        items: [
          {
            automationId: 'USERS_001',
            label: 'menu_main.users_list',
            icon: 'pi pi-fw pi-list',
            routerLink: 'users/list',
          },
        ],
      },
      {
        automationId: 'RFID_000',
        label: 'menu_main.rfid',
        icon: 'pi pi-fw pi-id-card',
        items: [
          {
            automationId: 'RFID_BT_001',
            label: 'menu_main.rfid_brand_tags',
            icon: 'pi pi-fw pi-bookmark',
            routerLink: 'settings/rfid/brand-tags',
          },
          {
            automationId: 'RFID_TCB_001',
            label: 'menu_main.rfid_tag_chip_brands',
            icon: 'pi pi-fw pi-microchip',
            routerLink: 'settings/rfid/tag-chip-brands',
          },
          {
            automationId: 'RFID_TR_001',
            label: 'menu_main.rfid_tag_references',
            icon: 'pi pi-fw pi-tag',
            routerLink: 'settings/rfid/tag-references',
          },
          {
            automationId: 'RFID_PT_001',
            label: 'menu_main.rfid_print_templates',
            icon: 'pi pi-fw pi-file-edit',
            routerLink: 'settings/rfid/print-templates',
          },
          {
            automationId: 'HW_002',
            label: 'menu_main.rfid_nodes',
            icon: 'pi pi-fw pi-wifi',
            items: [
              {
                automationId: 'HW_002',
                label: 'menu_main.rfid_nodes_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'rfid-nodes/list',
              },
            ],
          },
          {
            automationId: 'READ_000',
            label: 'menu_main.readers',
            icon: 'pi pi-fw pi-microchip',
            items: [
              {
                automationId: 'READ_001',
                label: 'menu_main.readers_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'settings/readers',
              },
            ],
          },
          {
            automationId: 'PRINT_001',
            label: 'menu_main.rfid_printers',
            icon: 'pi pi-fw pi-print',
            items: [
              {
                automationId: 'PRINT_001',
                label: 'menu_main.rfid_printers_list',
                icon: 'pi pi-fw pi-list',
                routerLink: 'rfid-nodes/printers/list',
              },
            ],
          },
        ],
      },
    ],
  },
  {
    automationId: 'INT_APPS_000',
    label: 'menu_main.integration_apps',
    icon: 'pi pi-fw pi-sitemap',
    items: [
      {
        automationId: 'INT_APPS_001',
        label: 'menu_main.integration_apps_list',
        icon: 'pi pi-fw pi-sitemap',
        routerLink: 'integration-apps',
      },
    ],
  },
];
